import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormattedListValue from '../../FormattedListValue';

const ResourceTypeRadioButtons = ({ value, onChange, disabled, types, name, className }) => {
  const handleOnChange = e => onChange(parseInt(e.target.value));
  return types && types.length > 1 ? (
    <div className="checkbox">
      {types.map(t => (
        <label key={t}>
          <input
            type="radio"
            value={t}
            name={name}
            id={`${name}-${t}`}
            checked={t === value}
            onChange={handleOnChange}
            disabled={disabled}
          />{' '}
          <FormattedListValue list="resourcetype" id={t} />
        </label>
      ))}
    </div>
  ) : null;
};

const allowedValues = [0, 1, 2, 3, 4];
ResourceTypeRadioButtons.propTypes = {
  value: PropTypes.oneOf(allowedValues),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  types: PropTypes.arrayOf(PropTypes.oneOf(allowedValues)),
  name: PropTypes.string,
  className: PropTypes.string,
};
ResourceTypeRadioButtons.defaultProps = {
  value: null,
  disabled: false,
  types: [0, 1, 2],
  name: 'ResourceType',
  className: '',
};
export default ResourceTypeRadioButtons;
